<script>
  import { onMount } from "svelte";
  import { categories } from "../config/categories";
  import { step, user } from "../stores";

  let showLegal = false;

  onMount(() => {});

  const onSubmit = ({ category }) => {
    user.update((u) => ({
      ...u,
      category,
    }));

    step.set(3);

    window.scrollTo(0, 0);
  };

  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );
  fbq("init", "1687524884947969");
  fbq("track", "PageView");
</script>

<noscript>
  <img
    height="1"
    width="1"
    style="display:none"
    src="https://www.facebook.com/tr?id=1687524884947969&ev=PageView&noscript=1"
  />
</noscript>

<div class="section section-1" style="min-height: 100vh">
  <div class="container">
    {#if window.location.search.indexOf("outbrain") > -1}
      <p
        style="text-align: center; color: #888; position: absolute; left: 0; right: 0;"
      >
        ADVERTORIAL
      </p>
    {/if}

    <div class="columns">
      <div class="column" style="text-align: center">
        <div style="text-align: center; margin-top: 48px;">
          <p>Seleziona di seguito la tua categoria lavorativa</p>
        </div>
      </div>
    </div>

    <p style="text-align: center;">⬇️ ⬇️ ⬇️</p>

    <div style="max-width: 450px; margin: 0 auto;">
      <div class="cta">
        {#each categories as category}
          <button on:click={() => onSubmit({ category: category.id })}
            >{category.label}</button
          >
        {/each}
      </div>
    </div>
  </div>
</div>

<footer>
  <div class="container" id="legal">
    <p>
      <a
        href="#legal"
        on:click={(e) => {
          showLegal = true;
        }}>Note legali</a
      >
    </p>

    {#if showLegal}
      <p>
        Messaggio pubblicitario con finalità promozionale - La presente pagina
        web è realizzata da WEDOS SRLS, in qualità di partner tecnico e
        pubblicitario. WEDOS SRLS non è un agente o un mediatore creditizio, non
        fornisce consulenza, né è parte del rapporto commerciale tra l’utente e
        l’operatore che riceve la richiesta, ma si limita a fornire la
        tecnologia necessaria affinché l’utente possa contattare direttamente
        l'operatore finanziario. La decisione di erogare il servizio finanziario
        si baserà sugli esiti di alcune indagine e sulla scelta espressa
        dall'operatore finanziario.
      </p>

      <p>
        La presente pagina web ospita annunci pubblicitari di istituti di
        crediti e intermediari finanziari, abilitati ad operare nel settore
        finanziario in Italia. Cliccando su uno dei pulsanti o link presenti in
        questa pagina, potrai entrare in contatto con un intermediario
        finanziario o con un istituto di credito. Potrai consultare tutte le
        condizioni contrattuali dei servizi finanziari offerti (inclusi il TAN e
        il TAEG eventualmente applicabili) consultando la documentazione che
        sarà messa a disposizione dall'operatore finanziario con cui entrerai in
        contatto.
      </p>

      <p>
        Tutte le informazioni fornite su questa pagina web sono a titolo
        puramente informativo e non costituiscono, nè sostituiscono, in alcun
        modo la consulenza di un esperto. I dati pubblicati su questa pagina
        web, relativi a servizi finanziari, sono stati espressamente approvati
        dagli operatori finanziari che erogano il servizio.
      </p>

      <p>
        Copyright © 2013 Siriofin S.p.A. • All Rights Reserved |
        <a
          href="https://www.siriofin.it/trasparenza.php"
          target="_blank"
          rel="noopener noreferrer">Privacy Policy</a
        >
      </p>

      <p>
        Sigla S.r.l. - società a socio unico - Reg. Imprese TV, cod. fisc.,
        part. IVA 03951740269 |
        <a
          href="https://siglacredit.it/informativa-sulla-privacy/"
          target="_blank"
          rel="noopener noreferrer">Privacy Policy</a
        >
      </p>

      <p>
        DFIN Srl Sede legale : Piazza Alessandro Volta, 33 - 22100 Como (CO) -
        C.C.I.A.A. Nr. CO-407510 C.F/P.Iva : IT01689500039 - Capitale Sociale €
        10.400,00 i.v. PEC:dfin@pec.it . Società iscritta all'elenco OAM al Nr.
        A13703 e al RUI tenuto dall'IVASS al Nr. E000682078. Il servizio
        consente di entrare in contatto con DFIN Srl, agenzia in attività
        finanziaria di Avvera SpA - società appartenente al Gruppo Bancario
        Credito Emiliano - CREDEM, regolarmente operante nel rispetto delle
        leggi vigenti in materia. Le caratteristiche dei prodotti e servizi
        proposti potranno subire delle variazioni in funzione alla valutazione
        del profilo di rischio complessivo e sono soggette all'esclusiva
        approvazione da parte dell'istituto erogante. In osservanza al D.lgs.
        1/9/93 n.385 sulla trasparenza delle operazioni finanziarie, tassi e
        condizioni sono riportati nei fogli informativi disponibili in sede o
        nella sezione trasparenza di questo sito.
      </p>

      <p>
        Pagina web realizzata da Wedos Srls P. IVA IT03543650125 in qualità di
        partner tecnico e media
      </p>
    {/if}
  </div>
</footer>

<style>
  .container {
    max-width: 900px;
    text-align: left;
  }

  :global(.selectContainer input) {
    font-size: 16px !important;
    top: 0;
  }

  .cta button {
    cursor: pointer;
    display: block;
    width: 100%;
    padding: 16px;
    margin-top: 8px;
    background-color: #2ecc71;
    color: white;
    font-weight: 700;
    text-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
    text-transform: uppercase;
  }

  .section-1 {
    background-color: #fafafa;
    border-bottom: 1px solid #ccc;
    padding: 0 0 32px;
  }

  .section-1 .columns {
    display: flex;
    flex-direction: column;
  }

  .section-1 .columns .column {
    width: 100%;
  }

  .section-1 .columns .column:last-child {
    margin-top: 24px;
  }

  @media screen and (min-width: 767px) {
    .section-1 .columns {
      flex-direction: row;
    }

    .section-1 .columns .column {
      width: 100%;
    }

    .section-1 .columns .column:last-child {
      margin-left: 24px;
    }
  }

  .section-who {
    text-align: center;
    padding: 24px 0;
  }

  .section-who h2 {
    text-align: center;
  }

  .section-advantages {
    text-align: center;
    padding: 24px 0;
  }

  .section-advantages h2 {
    text-align: center;
  }

  .section-advantages .columns {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .section-advantages .columns .column {
    width: 100%;
    text-align: center;
    margin-top: 32px;
    padding: 0 8px;
  }

  .section-advantages .columns .column img {
    width: 70px;
  }

  @media screen and (min-width: 767px) {
    .section-advantages .columns {
      flex-direction: row;
    }

    .section-advantages .columns .column {
      width: calc(25% - 16px);
    }
  }

  .section-how {
    text-align: center;
    background-color: #fafafa;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    padding: 24px 0;
  }

  .section-how h2 {
    text-align: center;
  }

  .section-how .columns {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .section-how .columns .column {
    width: 100%;
    text-align: center;
    margin-top: 32px;
    padding: 0 8px;
  }

  .section-how .columns .column img {
    width: 70px;
  }

  @media screen and (min-width: 767px) {
    .section-how .columns {
      flex-direction: row;
    }

    .section-how .columns .column {
      width: calc(33.3% - 16px);
    }
  }

  .section-cta {
    padding: 24px 0;
  }

  .section-cta h2,
  .section-cta p {
    text-align: center;
  }

  .section-cta .buttons-wrapper {
    max-width: 450px;
    margin: 32px auto 0;
  }

  button.cta {
    cursor: pointer;
    display: block;
    width: 100%;
    padding: 16px;
    background-color: #2ecc71;
    color: white;
    font-weight: 700;
    text-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
    text-transform: uppercase;
  }

  footer {
    font-size: 0.85rem;
    background-color: #fafafa;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    padding: 8px 0;
  }
</style>
